import { render, staticRenderFns } from "./CurriculumSection.vue?vue&type=template&id=c0eb41f4&"
import script from "./CurriculumSection.vue?vue&type=script&lang=js&"
export * from "./CurriculumSection.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumSection.vue?vue&type=style&index=0&id=c0eb41f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports